/**
 * Dispatches messages to the global-message store
 */
export default class MessageDispatcher {
    /**
     * dispatch root action to show global-message message
     * @param store
     * @param error
     */
    dispatchMessage(store, message, type) {
        return store.dispatch("global-message/setMessage", {
            text: message,
            type: type,
        }, { root: true });
    }
    /**
     *
     * @param store
     * @param message
     */
    dispatchSuccessMessage(store, message) {
        return this.dispatchMessage(store, message, "success");
    }
    /**
     *
     * @param store
     * @param message
     */
    dispatchErrorMessage(store, message) {
        return this.dispatchMessage(store, message, "error");
    }
    /**
     *
     * @param store
     * @param message
     */
    dispatchInfoMessage(store, message) {
        return this.dispatchMessage(store, message, "info");
    }
}
